<template>
  <v-card elevation="0">
    <v-text-field
      @input="searching"
      class="mx-4"
      prepend-inner-icon="mdi-magnify"
      label="Grupları Filtrele"
      hide-details
      clearable
    ></v-text-field>
    <v-list>
      <v-subheader class="mx-4">GRUPLAR</v-subheader>
      <v-list-item-group
        class="px-4"
        style="max-height: 42rem; overflow-y: auto; position: relative"
        active-class="primary--text"
      >
        <v-list-item
          v-for="(item, i) in data"
          :key="i"
          @click="$emit('rip:child', item)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="`${item.name} (${item.contacts_count})`">
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-overlay
          absolute
          :value="loading"
          opacity="0"
          z-index="2"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'SelectiveGroupList',
  props: {
    items: {
      type: Array,
      default: () => [],
      required: false,
    },
    searchLabel: {
      type: String,
      default: 'Search...',
      required: false,
    },
  },
  data: () => ({
    data: [],
    loading: true,
  }),
  watch: {
    items(nv) {
      this.data = nv;
      this.loading = false;
    },
  },
  methods: {
    ripChildChange($e) {
      this.$emit('rip:child', $e);
    },
    searching(val) {
      console.log(val);
      if (val === null) {
        this.data = this.items;
      } else {
        this.data = this.items.filter(item => item.name.includes(val));
      }
    },
  },
};
</script>
